import { useAppDispatch, useAppSelector, useTranslate } from '@common/hooks'
import { fetchApplicationRating } from '@redux/slices/applicationRating'
import cx from 'classnames'
import { Line } from 'rc-progress'
import { useCallback, useMemo } from 'react'

import classNames from './styles.module.scss'


export default function Bars(): JSX.Element | null {
  const { interpolate, translate } = useTranslate()
  const dispatch = useAppDispatch()
  const ratingSlice = useAppSelector(store => store.applicationRating)

  const handleFilterRating = useCallback((score: number) => {
    if(!ratingSlice.data) {
      return
    }
    const filterRating = ratingSlice.filters?.rating as number
    void dispatch(fetchApplicationRating({
      id: ratingSlice.data.app.id,
      rating: filterRating === score ? undefined : score,
      refresh: true,
    }))
  }, [ratingSlice])

  const progressBars = useMemo(() => {
    const ratingData = ratingSlice.data?.app
    const activeRating = ratingSlice.filters?.rating as number
    if(!ratingData) {
      return null
    }
    const totalRatings = ratingData.ratingScores.reduce((acc, curr) => acc + curr, 0)
    return [...ratingData.ratingScores].reverse().map((rating, index) => (
      <div
        key={index}
        data-test={`bars-row-${ratingData.ratingScores.length - index}`}
        className={cx(classNames.lineWrapper, activeRating === ratingData.ratingScores.length - index && classNames.active)}
        onClick={() => handleFilterRating(ratingData.ratingScores.length - index)}
      >
        <label className={classNames.label} data-test={`bars-label-${ratingData.ratingScores.length - index}`}>
          {interpolate(translate('%s stars'), [ratingData.ratingScores.length - index])}
        </label>
        <Line
          percent={(rating / totalRatings) * 100}
          className={classNames.line}
          strokeColor={(rating / totalRatings) * 100 === 0 ? 'transparent' : (!activeRating || activeRating === ratingData.ratingScores.length - index) ? '#2367ca' : '#a0bee8'}
          trailColor="#DFE4E8"
          data-test={`bars-progress-${ratingData.ratingScores.length - index}`}
        />
      </div>
    ))
  }, [ratingSlice])


  if(!ratingSlice.data) {
    return null
  }

  return (
    <div className={classNames.wrapper}>
      {progressBars}
    </div>
  )
}
